<template>
  <div>
    <!--内页通用尾部内容-->
    <div class="index_footer clearfix">
      <span class="footer_logo">
        <img src="@/assets/img/logo_white.png" alt />
      </span>
      <!--ul并排-->
      <ul class="footer_ul">
        <li>
          <p @click="$router.push({name: 'productCente'})">产品中心</p>
        </li>
        <li>
          <p @click="$router.push({name: 'productCente'})">产品介绍</p>
        </li>
        <!-- <li><a href="../view/productMeal.html">套餐服务</a></li> -->
        <li>
          <p @click="$router.push({name: 'productDownload'})">产品下载</p>
        </li>
      </ul>
      <ul class="footer_ul">
        <li>
          <p @click="$router.push({name: 'indusSolutionGovern'})">解决方案</p>
        </li>
        <li>
          <p @click="$router.push({name: 'indusSolutionGovern'})">电子政务</p>
        </li>
        <li>
          <p @click="$router.push({name: 'indusSolutionAffair'})">电子商务</p>
        </li>
        <li>
          <p @click="$router.push({name: 'indusSolutionSecure'})">保险信贷</p>
        </li>
        <li>
          <p @click="$router.push({name: 'indusSolutionTour'})">旅游行业</p>
        </li>
        <li>
          <p @click="$router.push({name: 'indusSolutionRent'})">房屋租赁</p>
        </li>
      </ul>
      <ul class="footer_ul">
        <li>
          <p @click="$router.push({name: 'lawProtect'})">使用保障</p>
        </li>
        <li>
          <p @click="$router.push({name: 'lawProtect'})">使用保障</p>
        </li>
      </ul>
      <ul class="footer_ul">
        <li>
          <p @click="$router.push({path: '/news/newsHy/3'})">新闻资讯</p>
        </li>
        <li>
          <p @click="$router.push({path: '/news/newsHy/3'})">行业动态</p>
        </li>
        <li>
          <p @click="$router.push({path: '/news/newsHy/4'})">政策法规</p>
        </li>
        <li>
          <p @click="$router.push({path: '/news/newsHy/6'})">合同百科</p>
        </li>
        <li>
          <p @click="$router.push({path: '/news/newsHy/7'})">法律知识</p>
        </li>
      </ul>
      <ul class="footer_ul">
        <li>
          <p @click="$router.push({name: 'aboutUs'})">关于我们</p>
        </li>
        <li>
          <p @click="$router.push({name: 'aboutUs'})">公司介绍</p>
        </li>
        <li>
          <p @click="$router.push({name: 'aboutUsEmploy'})">招聘信息</p>
        </li>
        <li>
          <p @click="$router.push({name: 'aboutUsAddress'})">联系我们</p>
        </li>
        <li>
          <p @click="$router.push({name: 'helpCenter'})">帮助中心</p>
        </li>
      </ul>
      <ul class="footer_ul">
        <li>
          <p @click="$router.push({name: 'contractIden'})">合同鉴真</p>
        </li>
        <li>
          <p @click="$router.push({name: 'contractIden'})">合同鉴真</p>
        </li>
      </ul>
      <ul class="footer_ul_diff">
        <li>联系我们</li>
        <li>邮箱地址：kefu@sdguodun.com</li>
        <li>邮政编码：250023</li>
        <li>电话号码：400-010-0303</li>
      </ul>
      <!--二维码-->
      <div class="footer_code">
        <div class="footer_code_left">
          <p>微信公众号</p>
          <img src="@/assets/img/qrcode_for_gh.png" alt />
        </div>
        <div class="footer_code_right">
          <p>进入官网</p>
          <img src="@/assets/img/code_img1.png" alt />
        </div>
      </div>
    </div>
    <p class="footer_btm">
      <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备18025351</a>号-3 |
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37010102001057" target="_blank">鲁公网安备 37010102001057号</a> |
      <span>2019-2020 山东国盾网信息科技有限公司 版权所有</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'BottomBar'
}
</script>

<style scoped>
.footer_ul {
  cursor: pointer;
}

.footer_ul p:hover {
  color: #0fc87d;
}
</style>